module.exports = __webpack_public_path__ + "img/hp-case-orange.2bf0281e.png";